import { render, staticRenderFns } from "./BeClear.vue?vue&type=template&id=1bd9a689&"
import script from "./BeClear.vue?vue&type=script&lang=js&"
export * from "./BeClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports